import './index.css';

import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App.tsx';
import { config, isAuthConfigured, loadConfig } from './config';

async function handleOidcCallback(): Promise<void> {
  const params = new URLSearchParams(window.location.search);
  if (!params.has('code') || !params.has('state')) return;
  if (!isAuthConfigured()) return;

  const mgr = new UserManager({
    authority: config.auth.authority,
    client_id: config.auth.clientId,
    redirect_uri: config.auth.redirectUri,
    scope: config.auth.scopes,
    response_type: 'code',
    userStore: new WebStorageStateStore({ store: window.localStorage }),
  });

  await mgr.signinRedirectCallback(window.location.href);
  window.history.replaceState({}, '', window.location.pathname + window.location.hash);
}

async function bootstrap() {
  await loadConfig();

  try {
    await handleOidcCallback();
  } catch (error) {
    // A stale/duplicate callback, expired code, or state/CSRF mismatch (e.g. the user
    // hit back after login, or reloaded mid-callback) must not block the app from
    // mounting -- fall through and let react-oidc-context land the user on /login.
    console.error('OIDC callback handling failed, continuing to render unauthenticated', error);
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

bootstrap();
